import { ButtonProps } from "@animech/ui";
import { FunctionComponent } from "react";
import * as Styled from "./cart-button.style";
import { Term } from "@definitions";
import { useUiData } from "src/ui/data";

export const CartButton: FunctionComponent<ButtonProps> = (props) => {
	const { localizer, cart } = useUiData();
	const { onCheckout, enabled: cartEnabled, estimateEnabled } = cart;
	const addToCartTerm: Term = estimateEnabled
		? "cartSummaryRequestEstimate"
		: "cartSummaryAddToCart";

	if (!cartEnabled) {
		return null;
	}
	return (
		<Styled.Button {...props} onClick={onCheckout}>
			{localizer.localizeTerm(addToCartTerm)}
		</Styled.Button>
	);
};
